import * as tslib_1 from "tslib";
import { IgrSummaryRow } from "./igr-summary-row";
import { SummaryRowRoot } from "./SummaryRowRoot";
var IgrSummaryRowRoot = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrSummaryRowRoot, _super);
    function IgrSummaryRowRoot(props) {
        return _super.call(this, props) || this;
    }
    IgrSummaryRowRoot.prototype.createImplementation = function () {
        return new SummaryRowRoot();
    };
    Object.defineProperty(IgrSummaryRowRoot.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrSummaryRowRoot;
}(IgrSummaryRow));
export { IgrSummaryRowRoot };
//# sourceMappingURL=igr-summary-row-root.js.map
